import { Table } from 'antd';
import 'antd/dist/antd.min.css'

const TabReport = (props) => {
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    
    const columns = [
        {
            title: 'Chỉ số',
            dataIndex: 'name',
            render: (data) => {
                return (
                    <p className="text1">{data}</p>
                )
            },
        },
        {
            title: 'FB',
            align: "center",
            render: (data, r) => {
                return (
                    <p className="text4">{r['name'] == 'AOV' || r['name'] == 'Doanh số dự kiến online' ?convertCurrency(r['fb']) :  r['fb'] }</p>
                )
            },
        },
        {
            title: 'IG',
            align: "center",
            render: (data, r) => {
                return (
                    <p className="text4">{r['name'] == 'AOV' || r['name'] == 'Doanh số dự kiến online' ? convertCurrency(r['ig']) :  r['ig'] }</p>
                )
            },
        },
        {
            title: 'Khác',
            align: "center",
            render: (data, r) => {
                return (
                    <p className="text4">{r['name'] == 'AOV' || r['name'] == 'Doanh số dự kiến online' ? convertCurrency(r['ot']) :  r['ot'] }</p>
                )
            },
        },
        {
            title: 'Tổng',
            align: "center",
            render: (data, r) => {
                return (
                    <p className="text1">{r['name'] == 'AOV' || r['name'] == 'Doanh số dự kiến online' ? convertCurrency(Number(r['totalS'])) :  r['totalS'] }</p>
                )
            },
        },
    ];

    return (
        <Table 
            columns={columns} 
            dataSource={props.table}
            pagination={{ pageSize: 8 }}
            scroll={{ x: 600 }}
            bordered
            rowKey={'name'}
        />
    )
}
export default TabReport